import { render, staticRenderFns } from "./system_messages.vue?vue&type=template&id=f2ff4192&scoped=true"
import script from "./system_messages.vue?vue&type=script&lang=js"
export * from "./system_messages.vue?vue&type=script&lang=js"
import style0 from "./system_messages.vue?vue&type=style&index=0&id=f2ff4192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff4192",
  null
  
)

export default component.exports